import { TFunction } from "i18next";
import { z } from "zod";

export const passwordValidation = (t: TFunction<"ns1", undefined>) =>
  z
    .string()
    .min(8, t("personnel.Password must be at least 8 characters long"))
    .max(20, t("personnel.Password must be at most 20 characters long"))
    .refine((password) => /[a-z]/.test(password), {
      message: t(
        "personnel.Password must contain at least one lowercase letter",
      ),
    })
    .refine((password) => /[A-Z]/.test(password), {
      message: t(
        "personnel.Password must contain at least one uppercase letter",
      ),
    })
    .refine((password) => /\d/.test(password), {
      message: t("personnel.Password must contain at least one digit"),
    });

export const repasswordValidation = (t: TFunction<"ns1", undefined>) =>
  z.string().min(8, t("personnel.Password must be at least 8 characters long"));
